<script>
    import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from "sveltestrap";
    import TokenDetails from "../snippets/TokenDetails.svelte";
    import {writable} from "svelte/store";
    import ButtonLine from "../snippets/ButtonLine.svelte";

    export let showModal = writable(false);
    export let token;

    const toggle = () => ($showModal = !$showModal);
</script>

<Modal 
    {...$$restProps}
    backdrop="static" 
    isOpen={$showModal}
    scrollable
    size="xl"
    {toggle}
    on:open={() => jQuery('.modal:last .confirm-button').focus()}
>
    <ModalHeader {toggle}>Zertifikatsinformation</ModalHeader>
    <ModalBody>
        <TokenDetails {token} />
    </ModalBody>
    <ModalFooter>
        <ButtonLine>
            <Button class="confirm-button" on:click={toggle} color="primary" data-test-id="tokenDetailsModal-button-ok">OK</Button>
        </ButtonLine>
    </ModalFooter>
</Modal>
